import { section } from "@/neon";

import scrollIntoView from "@/lib/scrollIntoView";
import { focusFormStatus } from "@/lib/a11y";

section("newsletter", {
  onLoad() {
    focusFormStatus(this.container);
    this.scrollAnimation = scrollIntoView(this.container);
  },
  onUnload() {
    this.scrollAnimation.unload();
  },
});
